import {
  ChakraHStack,
  FAIconName,
  FireflyButton,
  ModalV2,
  Text,
} from '@equip.health/ui';
import { useEditPatientNoteFormContext } from '~/lib/contexts/EditPatientNoteFormContext';

interface NoteTemplateSwitchModalProps {
  clickedTemplateId: string | null;
  isOpen: boolean;
  closeModal: () => void;
  onCancel: () => void;
}

const modalArgs = {
  bodyStyle: {
    overflow: 'visible',
    padding: '312px',
  },
  footerStyle: {
    padding: '0px',
  },
  titleStyle: {
    flex: '1 0 0',
    padding: '0px',
  },
};

const TOP_LEVEL_ID = 'note-template-switch';

export const PatientNoteTemplateSwitchModal = ({
  clickedTemplateId,
  isOpen,
  closeModal,
  onCancel,
}: NoteTemplateSwitchModalProps) => {
  const {
    changeNoteTemplateRevision,
    isRefreshNoteTemplateRevisionDataFetching,
  } = useEditPatientNoteFormContext();

  const onConfirm = () => {
    changeNoteTemplateRevision(clickedTemplateId, closeModal);
  };

  return (
    <ModalV2
      footerContent={
        <ChakraHStack
          alignItems="center"
          display="flex"
          justifyContent="space-between"
          paddingTop="6px"
          width="100%"
        >
          <FireflyButton
            id={`${TOP_LEVEL_ID}-modal__cancel`}
            isDisabled={isRefreshNoteTemplateRevisionDataFetching}
            leftIcon={FAIconName.timesRegular}
            onClick={onCancel}
            variant="secondary"
          >
            Cancel
          </FireflyButton>
          <FireflyButton
            id={`${TOP_LEVEL_ID}-modal__confirm`}
            isLoading={isRefreshNoteTemplateRevisionDataFetching}
            leftIcon={FAIconName.repeatRegular}
            onClick={onConfirm}
          >
            Switch template
          </FireflyButton>
        </ChakraHStack>
      }
      id={TOP_LEVEL_ID}
      isOpen={isOpen}
      onClose={onCancel}
      onEscape={onCancel}
      size="xl"
      title="Switching note templates"
      {...modalArgs}
    >
      <Text alignSelf="stretch" id={`${TOP_LEVEL_ID}-modal__body`}>
        Switching to a different template will discard all existing note
        content, including saved data.
      </Text>
      <Text mt="10px">Are you sure you want to proceed?</Text>
    </ModalV2>
  );
};
